import ParquedasFlores from '@/views/ParquedasFlores.vue';
import CemiterioPrevida from '@/views/CemiterioPrevida.vue';
import ParquedoAgreste from '@/views/ParquedoAgreste.vue';
import Memorial from '@/views/SiteMemorial.vue';
import SitePrevida from '@/views/SitePrevida.vue';
import Home from '@/views/HomeIndex.vue';
import VelorioVirtual from '@/components/VelorioVirtual.vue';
import GrupoParque from '@/views/GrupoParque.vue';
import CemiterioPrevidaArapiraca from '@/views/CemiterioPrevidaArapiraca.vue';

import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  { path: '/', component: GrupoParque },
  { path: '/empresas', component: Home},
  { path: '/parquedasflores', component: ParquedasFlores},
  { path: '/cemiterioprevida', component: CemiterioPrevida },
  { path: '/parquedoagreste', component: ParquedoAgreste},
  { path: '/memorial', component: Memorial },
  { path: '/previda', component: SitePrevida},
  { path: '/velorios', component: VelorioVirtual },
  { path: '/cemiterioprevidaarapiraca', component: CemiterioPrevidaArapiraca }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
